import { FC } from 'react';

import { NavLink } from 'react-router-dom';

import {
  IconILAB,
  IconIBOSS,
  IconUser,
  IconReports,
  IconBilling,
  IconCollaborators,
} from '~/assets/icons';
import { ImageLogoHeader } from '~/assets/images';
import { useAuth } from '~/hooks/auth.context';

import { Container } from './styles';

interface SidebarProps {
  sidebarIsVisible: boolean;
}

const Sidebar: FC<SidebarProps> = ({ sidebarIsVisible }) => {
  const { user } = useAuth();

  return (
    <Container visible={sidebarIsVisible}>
      <header>
        <img src={ImageLogoHeader} alt="Logo" />

        <h1>Intelligent Business</h1>
      </header>

      {user?.role === 'admin' && (
        <>
          <NavLink to="/users">
            <section>
              <IconUser />
              <p>Treinadores</p>
            </section>
          </NavLink>

          <NavLink to="/ilab">
            <section>
              <IconILAB />
              <p>I.LAB</p>
            </section>
          </NavLink>

          <NavLink to="/iboss">
            <section>
              <IconIBOSS />
              <p>I.BOSS</p>
            </section>
          </NavLink>

          <NavLink to="/collaborators">
            <section>
              <IconCollaborators />
              <p>Colaboradores</p>
            </section>
          </NavLink>

          <NavLink to="/billing">
            <section>
              <IconBilling />
              <p>Faturamento</p>
            </section>
          </NavLink>

          <NavLink to="/reports">
            <section>
              <IconReports />
              <p>Relatórios</p>
            </section>
          </NavLink>
        </>
      )}

      {user?.role === 'collaborator' && (
        <>
          {user?.collaborator?.modules.includes('módulo 1') && (
            <NavLink to="/users">
              <section>
                <IconUser />
                <p>Treinadores</p>
              </section>
            </NavLink>
          )}

          {user?.collaborator?.modules.includes('módulo 2') && (
            <NavLink to="/ilab">
              <section>
                <IconILAB />
                <p>I.LAB</p>
              </section>
            </NavLink>
          )}

          {user?.collaborator?.modules.includes('módulo 3') && (
            <NavLink to="/iboss">
              <section>
                <IconIBOSS />
                <p>I.BOSS</p>
              </section>
            </NavLink>
          )}

          {user?.collaborator?.modules.includes('módulo 4') && (
            <NavLink to="/collaborators">
              <section>
                <IconCollaborators />
                <p>Colaboradores</p>
              </section>
            </NavLink>
          )}

          {user?.collaborator?.modules.includes('módulo 5') && (
            <NavLink to="/reports">
              <section>
                <IconReports />
                <p>Relatórios</p>
              </section>
            </NavLink>
          )}
        </>
      )}

      {/* <NavLink to="/coupons">
        <section>
          <IconCoupons />
          <p>Cupons</p>
        </section>
      </NavLink> */}
    </Container>
  );
};

export default Sidebar;
